import { userService } from '../../helpers/authservice/user.service';
import router from '../../router/index'

const SecretKey = process.env.VUE_APP_SECRET_KEY;
const CryptoJS = require("crypto-js");

const user  = JSON.parse(localStorage.getItem('user'));
const role  = localStorage.getItem('rl') != undefined ? CryptoJS.AES.decrypt(localStorage.getItem('rl').toString(), SecretKey).toString(CryptoJS.enc.Utf8) : null;
const id  = localStorage.getItem('id') != undefined ? CryptoJS.AES.decrypt(localStorage.getItem('id').toString(), SecretKey).toString(CryptoJS.enc.Utf8) : null;
// const token = CryptoJS.AES.decrypt(localStorage.getItem('token').toString(), SecretKey).toString(CryptoJS.enc.Utf8);
export const state = user
    ? { status: { loggeduser: true }, user, role, id }
    : { status: {}, user: null, role: null, id: null };

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', { username });

        userService.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    // Log in after two factor authentication
    tfalogin({ dispatch, commit }, userData) {
        commit('loginSuccess', userData)
    },

    // Logout the user
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    // register the user
   
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user   = user.user;
        state.role   = user.role;
        state.token  = user.token;
        state.id     = user.id;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user   = user.user;
        state.role   = user.role;
        state.token  = user.token;
        state.id     = user.id;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    }
};